
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetActivatedSelectedIec as ObiAisTargetActivatedSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-activated-selected-iec.js';
 
 
 

 
 export const ObiAisTargetActivatedSelectedIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-activated-selected-iec',
   elementClass: ObiAisTargetActivatedSelectedIecElement,
   events: {
     
   }
  });
 
 